import {
    createStyles,
    Drawer,
    Hidden,
    makeStyles,
    Theme,
    useTheme,
} from "@material-ui/core";
import * as React from "react";
import { ReactNode } from "react";
// import Header from "./Header";
import { SideBar, SIDEBAR_WIDTH } from "./SideBar";

interface AppWrapperProps {
    window?: () => Window;
    children: ReactNode;
}

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {
            display: "flex",
        },
        drawer: {
            [theme.breakpoints.up("md")]: {
                width: SIDEBAR_WIDTH,
                flexShrink: 0,
            },
        },
        menuButton: {
            marginRight: theme.spacing(2),
            [theme.breakpoints.up("md")]: {
                display: "none",
            },
        },
        // necessary for content to be below app bar
        toolbar: theme.mixins.toolbar,
        drawerPaper: {
            width: SIDEBAR_WIDTH,
            position: "fixed",
            borderRight: 0,
            zIndex: 1111, // 1 more than AppBar
            // paddingTop: theme.spacing(8),
            // boxShadow: '1px 0px 6px rgba(0,0,0,0.2)',
            // backgroundColor: '#fafafa'
        },
        content: {
            backgroundColor: theme.palette.background.paper,
            flexGrow: 1,
        },
    })
);

export function AppWrapper(props: AppWrapperProps) {
    const { window } = props;
    const classes = useStyles();
    const theme = useTheme();
    const [mobileOpen, setMobileOpen] = React.useState(false);

    const container =
        window !== undefined ? () => window().document.body : undefined;

    const handleDrawerToggle = () => {
        setMobileOpen(!mobileOpen);
    };

    return (
        <React.Fragment>
            {/* <Header handleToggle={() => setMobileOpen(!mobileOpen)} /> */}
            <nav className={classes.drawer} aria-label="mailbox folders">
                {/* The implementation can be swapped with js to avoid SEO duplication of links. */}
                <div className={classes.toolbar} />
                <Hidden smUp implementation="css">
                    <Drawer
                        container={container}
                        variant="temporary"
                        anchor={theme.direction === "rtl" ? "right" : "left"}
                        open={mobileOpen}
                        onClose={handleDrawerToggle}
                        classes={{
                            paper: classes.drawerPaper,
                        }}
                        ModalProps={{
                            keepMounted: true, // Better open performance on mobile.
                        }}
                    >
                        <SideBar />
                    </Drawer>
                </Hidden>
                <Hidden smDown implementation="css">
                    <Drawer
                        classes={{
                            paper: classes.drawerPaper,
                        }}
                        variant="permanent"
                        open
                    >
                        <SideBar />
                    </Drawer>
                </Hidden>
            </nav>
            <main className={classes.content}>
                <div className={classes.toolbar} />
                {props.children}
            </main>
        </React.Fragment>
    );
}
